var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "noOrderListIcon",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1634_30402)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C5.38358 0 0 5.38232 0 12C0 18.6164 5.38358 24 12 24C18.6164 24 24 18.6164 24 12C24 5.38232 18.6164 0 12 0Z",
    fill: "url(#paint0_linear_1634_30402)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0434 9.75456L11.2102 15.5878C11.0245 15.7735 10.7832 15.8657 10.5407 15.8657C10.2969 15.8657 10.0556 15.7735 9.86995 15.5878L6.95336 12.6712C6.58325 12.3011 6.58325 11.7011 6.95336 11.331C7.32347 10.9609 7.9222 10.9609 8.29231 11.331L10.5407 13.5781L15.7032 8.4143C16.0733 8.04419 16.6733 8.04419 17.0434 8.4143C17.4135 8.7844 17.4135 9.3844 17.0434 9.75456Z",
    fill: "url(#paint1_linear_1634_30402)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1634_30402",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2D1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1634_30402",
    x1: 6.67578,
    y1: 8.13672,
    x2: 6.67578,
    y2: 15.8657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1634_30402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheckCircle);
export default __webpack_public_path__ + "static/media/ic_check_circle.a63c0f1f.svg";
export { ForwardRef as ReactComponent };